import { Link } from 'react-router-dom';

const footerLinks = {
  navigation: [
    { label: '首页', href: '/' },
    { label: '日漫', href: '/category/japanese' },
    { label: '韩漫', href: '/category/korean' },
    { label: '国漫', href: '/category/chinese' },
    { label: '已完结', href: '/category/completed' },
  ],
  about: [
    { label: '关于我们', href: '/about' },
    { label: '品牌介绍', href: '/about#brand' },
    { label: '联系我们', href: '/about#contact' },
  ],
  tags: ['热血', '恋爱', '奇幻', '冒险', '搞笑', '战斗', '悬疑', '玄幻'],
};

export default function Footer() {
  return (
    <footer className="bg-secondary-100 border-t border-background-200/70">
      <div className="px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-4">
              <span className="text-2xl font-heading font-bold text-primary-500">酷漫屋</span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              酷漫屋提供海量<strong>免费漫画</strong>资源，支持<strong>免费看漫画</strong>、<strong>免费在线漫画</strong>，下拉式滚动阅读，日漫韩漫国漫免费看，漫画免费追更。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50 text-foreground-600 hover:text-primary-500 transition-colors" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50 text-foreground-600 hover:text-primary-500 transition-colors" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50 text-foreground-600 hover:text-primary-500 transition-colors" aria-label="QQ">
                <i className="ri-qq-line"></i>
              </a>
            </div>
          </div>

          {/* Navigation Links */}
          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4 font-heading">
              <Link to="/category/all" className="hover:text-primary-500 transition-colors">快速导航</Link>
            </h4>
            <ul className="space-y-2">
              {footerLinks.navigation.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* About Links */}
          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4 font-heading">
              <Link to="/about" className="hover:text-primary-500 transition-colors">关于</Link>
            </h4>
            <ul className="space-y-2">
              {footerLinks.about.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Tags */}
          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4 font-heading">热门标签</h4>
            <div className="flex flex-wrap gap-2">
              {footerLinks.tags.map((tag) => (
                <span
                  key={tag}
                  className="px-3 py-1 text-xs bg-background-50 text-foreground-600 rounded-full border border-background-200/70 cursor-pointer hover:bg-primary-100 hover:text-primary-700 hover:border-primary-200 transition-colors duration-200 whitespace-nowrap"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; 2026 酷漫屋 - 免费漫画在线阅读平台。本站所有漫画均来自网络，版权归原作者所有。
          </p>
          <p className="text-xs text-foreground-500">
            酷漫屋 | 免费漫画 | 免费在线漫画
          </p>
        </div>
      </div>
    </footer>
  );
}